// extracted by mini-css-extract-plugin
export default {"container":"JQZ8udWgP_OS9rgwIfXA","active":"ZSr4ty2PC2sdfPioONRq","dots":"aBURhdBkUL7HsuWCeC0q","label":"Ko9OH455TzuorKeDxyJd"};